import React, { useMemo } from 'react';
import { SearchableSelect } from './AppSelect';

const normalize = (value) => (value === undefined || value === null ? '' : String(value));

const resolveCountryValue = (country, valueField) => {
    if (!country || typeof country !== 'object') {
        return '';
    }

    if (typeof valueField === 'function') {
        return valueField(country);
    }

    if (valueField === 'name') {
        return country.name ?? '';
    }

    if (valueField === 'code') {
        return country.code ?? country.iso ?? country.iso2 ?? country.iso_code ?? '';
    }

    return country.id ?? country.code ?? country.name ?? '';
};

const CountrySelect = ({
    countries = [],
    value = '',
    onChange,
    valueField = 'id',
    includeIsoInLabel = false,
    className,
    ...rest
}) => {
    const options = useMemo(
        () => (Array.isArray(countries) ? countries : []).map((country) => ({
            value: resolveCountryValue(country, valueField),
            label: includeIsoInLabel && country?.iso ? `${country.name} (${country.iso})` : (country?.name || ''),
            raw: country,
        })),
        [countries, includeIsoInLabel, valueField]
    );

    const selectedOption = useMemo(() => {
        const normalizedValue = normalize(value && typeof value === 'object' && 'value' in value ? value.value : value);
        return options.find((option) => normalize(option?.value) === normalizedValue) || null;
    }, [options, value]);

    return (
        <SearchableSelect
            className={className}
            options={options}
            value={selectedOption}
            onChange={(event, nextValue, selected) => onChange?.(selected?.raw || null, nextValue, selected || null, event)}
            {...rest}
        />
    );
};

export default CountrySelect;
